/**
 * @generated SignedSource<<1fea39433f59440a7d22d238f8f7edfd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZipCodeFormContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EthereumConnectionZipCodeForm_viewer">;
  readonly " $fragmentType": "ZipCodeFormContent_viewer";
};
export type ZipCodeFormContent_viewer$key = {
  readonly " $data"?: ZipCodeFormContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ZipCodeFormContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ZipCodeFormContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EthereumConnectionZipCodeForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "00739c4d3aa102b2b7cde60d67fe82fd";

export default node;
